import {RefundSearch, RefundListResult, RefundDetailResult, Refund} from '../../model/agent/lianlian/refund';
import {LLPHomeResult} from '../../response/homeresult';
import {TransactionDetail} from '../../model/shared/transaction/transaction';
import {User} from '../../model/shared/user/user';
import {BaseResponse} from '../../response/internal/baseresponse';
import {Api} from '../config/api';
import {AgentService} from './agent.service';
import {RequestService} from './request.service';
import {SessionService} from './session.service';
import {UserService} from './user.service';
import {Injectable} from '@angular/core';
import {RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class LLPAgentService extends AgentService {

  constructor(public request: RequestService,
    protected _user: UserService,
    public sessionService: SessionService) {
    super(request, _user, sessionService);
    this._options = new RequestOptions();
    this._options.headers = _user._options.headers;
    this._loginSubscription = sessionService.loginChange;
    this._loginSubscription.subscribe((value) => {
      this._isLogin = value;
    });
  }

  /*LianLian*/
  setKycStatus(customer: User): Observable<BaseResponse> {
    return this.request.postBasic(Api.LianLian.Agent.KYCSet, this._options, customer, BaseResponse);
  }

  setTxnStatus(txn: TransactionDetail): Observable<BaseResponse> {
    return this.request.postBasic(Api.LianLian.Agent.TXNSet, this._options, txn, BaseResponse);
  }

  llphome(): Observable<LLPHomeResult> {
    return this.request.getBasic(Api.LianLian.Agent.Home, this._options, LLPHomeResult);
  }

  refundlist(param: RefundSearch): Observable<RefundListResult> {
    return this.request.postBasic(Api.LianLian.Agent.RefundList, this._options, param, RefundListResult);
  }

  refunddetail(id: string): Observable<RefundDetailResult> {
    return this.request.getBasic(Api.LianLian.Agent.RefundDetail(id), this._options, RefundDetailResult);
  }

  updateRefundStatus(param: Refund): Observable<RefundDetailResult> {
    return this.request.postBasic(Api.LianLian.Agent.updateRefundStatus, this._options, param, RefundDetailResult);
  }

  addRefund(param: Refund): Observable<RefundDetailResult> {
    return this.request.postBasic(Api.LianLian.Agent.insertRefund, this._options, param, RefundDetailResult);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/llpagent.service.ts